import Layout from '@/components/feature/Layout';
import ScrollReveal from '@/components/base/ScrollReveal';
import JsonLd from '@/components/base/JsonLd';
import { WaveDivider, CurvedDivider } from '@/components/base/SectionDividers';
import HeroSection from './components/HeroSection';
import OverviewSection from './components/OverviewSection';
import FeaturesSection from './components/FeaturesSection';
import ServicesSection from './components/ServicesSection';
import ProjectsPreviewSection from './components/ProjectsPreviewSection';
import PartnersSection from './components/PartnersSection';
import ProcessSection from './components/ProcessSection';
import TestimonialsFAQSection from './components/TestimonialsFAQSection';
import { useTranslation } from 'react-i18next';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'IS TELECOM',
  url: 'https://is-telecom.co',
  logo: 'https://static.readdy.ai/image/91fcefbb4717a40f72927278ebfb44c9/b21d4969bbd2d15083f7f8fa7d846874.png',
  description: 'Leader en infrastructures de télécommunication et énergies renouvelables depuis 2006. Tours de télécommunication, micro-réseaux solaires, pompage solaire, stockage d\'énergie, construction métallique, transport et logistique.',
  foundingDate: '2006',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Cotonou',
    addressLocality: 'Cotonou',
    addressCountry: 'BJ',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+229-01-95-89-27-55',
    email: 'contact@is-telecom.co',
    contactType: 'customer service',
    availableLanguage: ['French', 'English'],
  },
  sameAs: [
    'https://www.facebook.com/istelecom',
    'https://www.linkedin.com/company/is-telecom',
  ],
};

export default function Home() {
  const { t } = useTranslation();

  const homeFAQSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: t('faq.homeFaqs.0.q'), acceptedAnswer: { '@type': 'Answer', text: t('faq.homeFaqs.0.a') } },
      { '@type': 'Question', name: t('faq.homeFaqs.1.q'), acceptedAnswer: { '@type': 'Answer', text: t('faq.homeFaqs.1.a') } },
      { '@type': 'Question', name: t('faq.homeFaqs.2.q'), acceptedAnswer: { '@type': 'Answer', text: t('faq.homeFaqs.2.a') } },
      { '@type': 'Question', name: t('faq.homeFaqs.3.q'), acceptedAnswer: { '@type': 'Answer', text: t('faq.homeFaqs.3.a') } },
    ],
  };

  return (
    <Layout>
      <JsonLd data={organizationSchema} />
      <JsonLd data={homeFAQSchema} />

      {/* 1. Hero — parallax background inside */}
      <HeroSection />

      <ScrollReveal variant="fade-up">
        <OverviewSection />
      </ScrollReveal>

      <ScrollReveal variant="fade-up" delay={100}>
        <FeaturesSection />
      </ScrollReveal>

      <ScrollReveal variant="fade-up" delay={100}>
        <ServicesSection />
      </ScrollReveal>

      <ScrollReveal variant="fade-up" delay={100}>
        <ProjectsPreviewSection />
      </ScrollReveal>

      {/* Curved transition: dark projects → white partners */}
      <CurvedDivider
        fromColor="oklch(var(--background-900))"
        toColor="#ffffff"
        height={100}
      />

      <ScrollReveal variant="fade-in" delay={100}>
        <PartnersSection />
      </ScrollReveal>

      {/* Wave transition: white partners → light process */}
      <WaveDivider
        fromColor="#ffffff"
        toColor="oklch(var(--background-50))"
        height={80}
      />

      <ScrollReveal variant="fade-up" delay={100}>
        <ProcessSection />
      </ScrollReveal>

      <ScrollReveal variant="fade-up" delay={100}>
        <TestimonialsFAQSection />
      </ScrollReveal>
    </Layout>
  );
}